import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* refreshToken(action) {
  const jwt = localStorage.getItem("_jwt");

  // if we do not have a jwt then do not refresh
  if (!jwt) {
    return;
  }

  var payload = {
    action: "portal/refreshToken",
    jwt,
  };
  yield put(serverRequest(payload));
}

export default refreshToken;
